export const END_OF_TREATMENT_CALL = 'end_of_treatment_call'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/end-of-treatment/task-name.js